import vnLangLib from '../locales/en_VN';

const vnLang = {
  messages: {
    ...vnLangLib,
  },
  locale: 'en-VN',
};
export default vnLang;
